export const PROJECT_TYPES = [
  { value: "website", label: "Website" },
  { value: "changes_to_existing_site", label: "Changes to Existing Site" },
  { value: "migrations", label: "Migrations" },
  { value: "marketing", label: "Marketing" },
  { value: "custom", label: "Custom" },
];

export const projectTypeLabel = (v) => PROJECT_TYPES.find((t) => t.value === v)?.label || v;

export const ACCESS_VISIBLE_TYPES = ["website", "changes_to_existing_site", "migrations"];

export const PROJECT_STATUS_STYLES = {
  active: "bg-emerald-100 text-emerald-700",
  suspended: "bg-amber-100 text-amber-700",
  closed: "bg-slate-200 text-slate-600",
};

export const formatAUDAmount = (a) =>
  new Intl.NumberFormat("en-AU", { style: "currency", currency: "AUD" }).format(a || 0);

export const EditHistoryNote = ({ history, field }) => {
  const items = (history || []).filter((h) => h.field === field);
  if (items.length === 0) return null;
  return (
    <div className="mt-1 space-y-0.5" data-testid={`edit-history-${field}`}>
      {items.slice(-3).map((h, i) => (
        <p key={`${h.edited_date}-${i}`} className="text-xs text-amber-600">
          Edited by <b>{h.edited_by}</b> on {new Date(h.edited_date).toLocaleString("en-AU")} — changed from "{String(h.old ?? "").slice(0, 60) || "—"}" to "{String(h.new ?? "").slice(0, 60)}"
        </p>
      ))}
    </div>
  );
};
